// Library methods
import { useTranslation } from "react-i18next";

// Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

type VisualAcuityHeaderType = {
  chartTitle?: string;
  isLiveUpdate?: boolean;
};

const VisualAcuityHeader = ({
  chartTitle,
  isLiveUpdate = false,
}: VisualAcuityHeaderType) => {
  const { t } = useTranslation();

  // Smaller text on narrow screens in the live update view, matching
  // VisualAcuityScale/VisualAcuityIndex.
  const fontSize = isLiveUpdate ? { xs: "11px", sm: "14px" } : "14px";

  return (
    <>
      <Grid item display="flex" xs={12}>
        <Grid item xs={3} sx={{ minWidth: 0 }}>
          <Typography
            noWrap
            textAlign="center"
            fontSize={fontSize}
            fontWeight={600}
          >
            {t("Snellen Equivalent")}
          </Typography>
        </Grid>
        <Grid item xs={6} sx={{ minWidth: 0 }}>
          <Typography
            noWrap
            textAlign="center"
            fontSize={fontSize}
            fontWeight={600}
          >
            {chartTitle}
          </Typography>
        </Grid>
        <Grid container item xs={3} sx={{ minWidth: 0 }}>
          <Grid item xs={6} sx={{ minWidth: 0 }}>
            <Typography
              noWrap
              textAlign="center"
              fontSize={fontSize}
              fontWeight={600}
            >
              {t("LogMAR")}
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ minWidth: 0 }}>
            <Typography
              noWrap
              textAlign="center"
              fontSize={fontSize}
              fontWeight={600}
            >
              {t("Index")}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item display="flex" xs={3} mb="20px">
        <Grid item xs={6} sx={{ minWidth: 0 }}>
          <Typography
            noWrap
            textAlign="center"
            fontSize={fontSize}
            fontWeight={600}
          >
            20 / {t("Foot")}
          </Typography>
        </Grid>
        <Grid item xs={6} sx={{ minWidth: 0 }}>
          <Typography
            noWrap
            textAlign="center"
            fontSize={fontSize}
            fontWeight={600}
          >
            6 / {t("Meter")}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default VisualAcuityHeader;
